import { Icon, Button } from '@nimbus-ds/components';
import { InterfaceButton } from '@tiendanube/components';
import { ChevronLeftIcon } from '@tiendanube/icons';
import { useTopAdBar } from 'App/components/TopAdBar/useTopAdBar';
import useTopBar from 'App/components/Topbar/useTopBar';

import './BackNavigation.scss';

export type BackNavigationProps = Pick<
  InterfaceButton,
  'children' | 'onClick'
> & {
  from?: 'topbar' | 'aside-modal';
};

function BackNavigation({
  children,
  onClick,
  from = 'aside-modal',
}: BackNavigationProps): JSX.Element {
  const { isShowTopbar, height: heightTopBar } = useTopBar();
  const { height: heightTopAdBar } = useTopAdBar();
  const offset = isShowTopbar ? heightTopAdBar : heightTopBar + heightTopAdBar;

  // This style reverses the topbar hiding by reversing its translation
  // This ensures that the component stays visible at all times.
  const style = {
    ...(from === 'topbar' && { transform: `translateY(${offset}px)` }),
  };

  return (
    <div
      id={`back-navigation-${from}`}
      className="stratus--page-navbar__back"
      style={style}
    >
      <Button
        key={`backNavigation-${0}`}
        onClick={onClick}
        appearance="transparent"
      >
        <Icon source={<ChevronLeftIcon />} color="neutral-textLow" />
        {children}
      </Button>
    </div>
  );
}

export default BackNavigation;
